import { render, staticRenderFns } from "./BpTooltip.vue?vue&type=template&id=a2b8ee68&scoped=true&"
import script from "./BpTooltip.vue?vue&type=script&lang=js&"
export * from "./BpTooltip.vue?vue&type=script&lang=js&"
import style0 from "./BpTooltip.vue?vue&type=style&index=0&id=a2b8ee68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b8ee68",
  null
  
)

export default component.exports